module.exports = __webpack_public_path__ + "static/img/icon-3.431c2eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-3.png
// module id = Bgus
// module chunks = 7